<!--  -->
<template>
 <div style="">
        <Toolbar
            style="border-bottom: 1px solid #ccc"
            :editor="editor"
            :defaultConfig="toolbarConfig"
            :mode="mode"
        />
        <Editor
            style="height:1000px; overflow-y: hidden;"
            v-model="html"
            :defaultConfig="editorConfig"
            :mode="mode"
            @onCreated="onCreated"
            @onChange="onChange"
        />
  </div>
</template>

<script>
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import {applicationName} from '@/utils/const.js'
import { getToken} from '@/utils/auth'
import { Message, MessageBox } from 'element-ui'
import store from '../store'
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
props:["getHtml","insertHtml"],
//import引入的组件需要注入到对象中才能使用
components: {Editor, Toolbar },
data() {
//这里存放数据
return {
    applicationName:applicationName,
    editor: null,
    html: '<p>hello</p>',
    toolbarConfig: { },
    editorConfig: { 
        placeholder: '请输入内容...',
        MENU_CONF:{
            uploadImage:{
                server: `${process.env.VUE_APP_API_URL+applicationName}/admin/file/upload/imgs`,
                headers:{
                  Authorization:getToken()
                },
                customInsert({data}, insertFn) {
                //  insertFn(`${process.env.VUE_APP_API_URL.split(":")[0]}/${data.url}`, data.alt,`${process.env.VUE_APP_API_URL}/${data.href}`)
                insertFn(`${data.url}`, data.alt,`${process.env.VUE_APP_API_URL}/${data.href}`)
                }
            },
            uploadVideo:{
                server: `${process.env.VUE_APP_API_URL+applicationName}/admin/file/upload/video`,
                fieldName: 'video',
                maxFileSize: 50 * 1024 * 1024, 
                maxNumberOfFiles: 2,
                headers:{
                  Authorization:getToken()
                },
                timeout: 30 * 1000,
                                // 单个文件上传失败
                onFailed(file,{code}) {   // TS 语法
                if(code==401){
                    MessageBox.confirm(`${file.name.substr(5)+'...'} 上传失败,原因:登录超时请重新登录","确定登出`,{
                        confirmButtonText:"重新登录",
                        cancelButtonText:"取消",
                        type:"warning"
                    }).then(()=>{
                        store.dispatch("Logout").then(()=>{
                        location.reload()
                        })
                    })
                }
                    Message.error(`${file.name.substr(5)+'...'},上传失败`)
                },
                onError(file, err, res) {  // TS 语法
                    if(err.message.indexOf('maximum')>-1){
                        Message.error('请上传50MB及以下大小的视频文件!')
                        return;
                    }
                    MessageBox.confirm(`${file.name.substring(0,5)+'...'} 上传出错,原因:登录超时请重新登录,确定登出?`,{
                        confirmButtonText:"重新登录",
                        cancelButtonText:"取消",
                        type:"warning"
                    }).then(()=>{
                        store.dispatch("Logout").then(()=>{
                        location.reload()
                        })
                    })
                    console.log(err,res)
                },
                customInsert({data}, insertFn) {
                    // insertFn(`${process.env.VUE_APP_API_URL.split(":")[0]}/${data.url}`)
                    insertFn(`${data.url}`)
                }
            }
        },

     },
    mode: 'default', // or 'simple'
};
},
//监听属性 类似于data概念
computed: {},
//监控data中的数据变化
watch: {
    insertHtml(val){
       this.html=val
    }
},
//方法集合
methods: {
 onCreated(editor) {
            this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
        },
 onChange(){
    this.getHtml(this.html)
    console.log(this.editorConfig)
 }       
},
//生命周期 - 创建完成（可以访问当前this实例）
created() {

},
//生命周期 - 挂载完成（可以访问DOM元素）
mounted() {
 // 模拟 ajax 请求，异步渲染编辑器
        // setTimeout(() => {
        //     this.html = '<p>模拟 Ajax 异步设置内容 HTML</p>'
        // }, 1500)
},
beforeCreate() {}, //生命周期 - 创建之前
beforeMount() {}, //生命周期 - 挂载之前
beforeUpdate() {}, //生命周期 - 更新之前
updated() {}, //生命周期 - 更新之后
beforeDestroy() {
     const editor = this.editor
        if (editor == null) return
        editor.destroy() // 组件销毁时，及时销毁编辑器
}, //生命周期 - 销毁之前
destroyed() {}, //生命周期 - 销毁完成
activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style src="@wangeditor/editor/dist/css/style.css"></style>
<style lang='scss'>
/** scoped 表示 样式自在当前组件有效*/
//@import url(); 引入公共css类
// .w-e-textarea-video-container video{
//     width:100% !important;
// }
</style>
